import React from 'react';
import { ArrowRight, Wrench } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-marine-blue text-white" data-id="element-217">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-218">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-id="element-219">
          <div className="md:max-w-2xl" data-id="element-220">
            <h2 className="text-2xl md:text-3xl font-bold mb-2 leading-tight" data-id="element-221">
              CLR Marine carries fluid pumps and pump parts for every industry.
            </h2>
            <p className="text-slate-100/90" data-id="element-222">
              From marine engine cooling and bilge pumps to industrial fuel,
              oil, and chemical transfer — let us help you find the right pump
              or replacement part.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0" data-id="element-223">
            <a href="https://www.clrmarine.com/531.html" className="inline-flex items-center justify-center gap-2 bg-white text-marine-blue hover:bg-marine-cyan hover:text-marine-navy font-semibold px-5 py-3 rounded-lg transition-colors duration-150" data-id="element-224">
              Need help finding a pump?
              <ArrowRight className="w-4 h-4" data-id="element-225" />
            </a>
            <a href="https://www.clrmarine.com/544.html" className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-medium px-5 py-3 rounded-lg border border-white/30 transition-colors duration-150" data-id="element-226">
              <Wrench className="w-4 h-4" data-id="element-227" />
              Troubleshoot Your Pump
            </a>
          </div>
        </div>
      </div>
    </section>;
}